import CategoryBtn from "./categoryBtn";
import { useSelector, useDispatch } from "react-redux";
import { EMenuActions } from "../../store";
import React, { useState } from "react";
import { toast } from "react-toastify";



export default function CategorySection() {
	const dispatch = useDispatch();
	const allProducts = useSelector((state) => state.EMenu.all_products);
	const sub_category = useSelector((state) => state.EMenu.sub_category);
	const BranchId = useSelector((state) => state.Company.BranchId);
	const SalesPointName = useSelector((state) => state.Company.SalesPointName);
	const loadSubCat = useSelector((state) => state.EMenu.loadSubCat);
	const [activeId, setActiveId] = useState(false)

	const handleClick = async ({ id }) => {
		setActiveId(id === activeId ? null : id);
		dispatch(EMenuActions.setLoadProducts(true));
		dispatch(EMenuActions.setProducts([]));
		dispatch(EMenuActions.setSearch(false));
		const catProducts = allProducts.filter((product) => product.subgroupid == id);
		// console.log(activeId, id);
		if(catProducts.length > 0){
				  dispatch(EMenuActions.setProducts(catProducts));
				  console.log("loaded products: ", catProducts)
				  dispatch(EMenuActions.setLoadProducts(false));
		}else{
		  toast.error(`Category not found ⚠️`, {
			position: "bottom-right",
			autoClose: 1000,
			hideProgressBar: false,
			closeOnClick: true,
			pauseOnHover: true,
			draggable: true,
			progress: undefined,
			theme: "light",
		  });
		  return {
			statusCode: 500,
			body: JSON.stringify({ error: "Something went wrong" }),
		  };
		}
	  };

	return (
		<section className="px-6 max-sm:px-3 mt-2">
			{sub_category.length === 0 && !loadSubCat  ? (
				<p className="max-sm:mt-14 font-bold text-center">This Category is newly added we are still working on it</p>
			) : (
				<>
					<p className="text-base m-1 mb-2 uppercase tracking-wide font-extrabold text-dark">
						Category{" "}
						<span className="bg-secondary/10 rounded-md p-0.5 px-3 m-auto text-center uppercase text-xs font-bold text-secondary/70">
							{BranchId} - {SalesPointName}
						</span>
					</p>

					<div className="grid grid-flow-col gap-2 max-sm:gap-2 overflow-x-scroll">
						{sub_category.map((item) => (
							<CategoryBtn key={item.id} image={item.image} category={item.name} id={item.categoryid}
							handleClick={handleClick}
							active={activeId === item.categoryid}
							/>
						))}
					</div>
				</>
			)}
		</section>
	);
}
